import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const iriusRisk = defineConnector({
  identifier: "iriusRisk",
  name: "IriusRisk",
  tagLine: "Threat modeling",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://your-instance.iriusrisk.com/api/v1"),
  auth: headerAuth([
    { name: "api-token", value: { from: "secret", field: "apiToken" } },
  ]),
  steps: [
    {
      title: "Set up IriusRisk",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API token in your IriusRisk account. The connection test reads at most one project visible to your account and requires no additional permissions. Enter your tenant’s API URL and token below. See [API token setup](https://enterprise-support.iriusrisk.com/s/article/Generate-an-API-Key).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://your-instance.iriusrisk.com/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "The official API v1 specification uses demo.iriusrisk.com over HTTPS. For another tenant, use that tenant’s IriusRisk host and retain the /api/v1 path prefix; the vendor’s API guidance illustrates replacing the demo host with the customer’s instance host.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Generate an API key in your IriusRisk account using the official API-token guide, then enter the generated value here. The API request uses it as the api-token header value.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://your-instance.iriusrisk.com/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/products?max=1",
      ...{ method: "GET" },
    }),
  },
});
